export default {"src":"/_next/static/media/warning-icon.74079a5d.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};